
import './App.css';
import ScrollAnimation from './component/scroll-Animaiton/Scroll-Animation';

function App() {
  return ( 
    <div className="App">
      <ScrollAnimation/>
    </div>
  );
}

export default App;
